export default __webpack_public_path__ + "static/media/clairefontaine19.262a3299.jpg";